import clsx from 'clsx';
import { InputHTMLAttributes, ReactNode } from 'react';

import { Icon } from '../icon';

import './checkbox.scss';

export const Checkbox = (props: CheckboxProps) => {
  const { label, className, intermediate, ...restProps } = props;

  return (
    <label
      className={clsx('checkbox-holder', className, {
        intermediate,
      })}
    >
      <input
        type="checkbox"
        onClick={(e) => e.stopPropagation()}
        readOnly={restProps.readOnly || !restProps.onChange}
        {...restProps}
      />
      <small>
        <Icon type="tick-02" size={14} />
      </small>
      {/*{label && <div className="checkbox-label">{label}</div>}*/}
      {label}
    </label>
  );
};

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  className?: string;
  intermediate?: boolean;
}
